<template>
    <!-- <oss-dialog
        v-model="dialog"
        @close="close"
        @valid="valid"
        :validTitle="budgetId ? 'Modifier les montants reportés':'Initialiser votre budget'"
        :validLoading="validLoading"
        :width="width"
        :height="height"
        min-height="80vh"
    >

        <template v-slot:content> -->
    <!-- <v-card class="default_card large mx-0 my-2 pa-2" elevation="0">
                <v-row no-gutters>
                    <v-col cols="12" class="d-flex justify-start align-center pb-2">
                        <h2 class="my-2">Budgets prévisionnels</h2>
                    </v-col>
                </v-row>
            </v-card> -->
    <v-card style="background-color: transparent" elevation="0" class="mx-0">
        <!-- <v-row no-gutters>
                <v-col cols="4" class="d-flex mr-2">
                    <v-text-field
                        v-model="budgetName"
                        outlined
                        dense
                        class="oss-"
                    ></v-text-field>
                </v-col>
            </v-row> -->
        <v-tabs v-model="step" fixed-tabs>
            <v-tab value="1" href="#1" style="justify-content: left">
                <v-btn
                    depressed
                    class="pr-2"
                    :color="step === '1' ? 'primary' : '_grey'"
                    size="x-small"
                >
                    1
                </v-btn>
                Charges
            </v-tab>
            <!-- <v-tab value="3" href="#3" style="justify-content: left" v-if="chargesGroupingMode === 'AA'">
                    <v-btn
                        rounded="circle" depressed size=“x-small” class="btn"
                        :color="step === '3' ? 'primary' : '_grey'"
                    > 3 </v-btn>
                    Charges de vente
                </v-tab> -->
            <v-tab value="2" href="#2" style="justify-content: left">
                <v-btn
                    depressed
                    class="pr-2"
                    :color="step === '2' ? 'primary' : '_grey'"
                    size="x-small"
                >
                    2
                </v-btn>
                Activité
            </v-tab>
            <v-tab value="3" href="#3" style="justify-content: left">
                <v-btn
                    depressed
                    class="pr-2"
                    :color="step === '3' ? 'primary' : '_grey'"
                    size="x-small"
                >
                    3
                </v-btn>
                Personnel
            </v-tab>
        </v-tabs>
        <v-tabs-window v-model="step" style="overflow-y: auto">
            <v-window-item value="1" style="overflow-y: auto">
                <v-card style="box-shadow: none" class="d-flex flex-column">
                    <v-card-text stye="overflow-y: auto; height:75vh;">
                        <v-data-table
                            :headers="dataChargeTableHeader"
                            :items="formBfaa.charges"
                            :itemsPerPage="formBfaa.charges.length"
                            :single-expand="false"
                            v-model:expanded="chargesExpanded"
                            item-value="aaName"
                            hide-default-footer
                            :loading="loading"
                            class="table"
                            v-if="formBfaa.charges"
                            density="compact"
                        >
                            <template v-slot:expanded-row="{ columns, item }">
                                <td :colspan="columns.length">
                                    <v-card style="box-shadow: none" class="d-flex flex-column">
                                        <v-card-text stye="overflow-y: auto; height:75vh;">
                                            <v-data-table
                                                :headers="subLineTableHeadersStaff"
                                                :items="item.subLines"
                                                :itemsPerPage="item.subLines.length"
                                                item.key="companyName"
                                                hide-default-footer
                                                :loading="loading"
                                                class="table"
                                                elevation="0"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td class="pl-0 pr-2 py-0 ma-0">
                                                            <v-checkbox
                                                                v-model="props.item.toReport"
                                                                :ripple="false"
                                                                @change="
                                                                    changeYearlyLineSelection(
                                                                        props.item,
                                                                    )
                                                                "
                                                            >
                                                            </v-checkbox>
                                                        </td>
                                                        <td class="pl-0 pr-2 py-0 ma-0">
                                                            {{ props.item.companyName }}
                                                        </td>
                                                        <td class="pl-0 pr-2 py-0 ma-0">
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    props.item.amountNM1,
                                                                    undefined,
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-card-text>
                                    </v-card>
                                </td>
                            </template>
                            <template v-slot:[`item.toReport`]="{ item }">
                                <v-checkbox v-model="item.toReport" :ripple="false"> </v-checkbox>
                            </template>
                            <template v-slot:[`item.variability`]="{ item }">
                                <v-select-filled
                                    outlined
                                    v-model="item.variability"
                                    :items="chargeTypes"
                                    required
                                    single-line
                                    hide-details="auto"
                                    :disabled="!item.toReport"
                                    density="compact"
                                />
                            </template>
                            <template v-slot:[`item.amountNM1`]="{ item }">
                                {{ newCommonFormatCurrency(item.amountNM1, undefined) }}
                            </template>
                            <template
                                v-slot:[`item.actions`]="{ item }"
                                v-if="chargesGroupingMode === 'TPC'"
                            >
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <v-icon
                                            @click="
                                                mergingSource = item;
                                                displayMergeDialog = true;
                                            "
                                            v-bind="props"
                                            >$oss-edit</v-icon
                                        >
                                    </template>
                                    <span
                                        >Fusionner plusieurs lignes pour synthéthiser le budget
                                        généré</span
                                    >
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-window-item>
            <v-window-item value="3" style="overflow-y: auto">
                <v-card style="box-shadow: none" class="d-flex flex-column">
                    <v-card-text stye="overflow-y: auto; height:75vh;">
                        <v-data-table
                            :headers="dataTableHeader"
                            :items="formBfaa.staff"
                            :itemsPerPage="formBfaa.staff.length"
                            :single-expand="false"
                            v-model:expanded="staffExpanded"
                            item-value="aaName"
                            hide-default-footer
                            :loading="loading"
                            class="table"
                            v-if="formBfaa.staff"
                            density="compact"
                        >
                            <template v-slot:expanded-row="{ columns, item }">
                                <td :colspan="columns.length">
                                    <v-card style="box-shadow: none" class="d-flex flex-column">
                                        <v-card-text stye="overflow-y: auto; height:75vh;">
                                            <v-data-table
                                                :headers="subLineTableHeaders"
                                                :items="item.subLines"
                                                :itemsPerPage="item.subLines.length"
                                                item.key="companyName"
                                                hide-default-footer
                                                :loading="loading"
                                                class="table"
                                                elevation="0"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td class="pl-0 pr-2 py-0 ma-0">
                                                            <v-checkbox
                                                                v-model="props.item.toReport"
                                                                :ripple="false"
                                                                @change="
                                                                    changeYearlyLineSelection(
                                                                        props.item,
                                                                    )
                                                                "
                                                            >
                                                            </v-checkbox>
                                                        </td>
                                                        <td class="pl-0 pr-2 py-0 ma-0">
                                                            {{ props.item.companyName }}
                                                        </td>
                                                        <td class="pl-0 pr-2 py-0 ma-0">
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    props.item.amountNM1,
                                                                    undefined,
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-card-text>
                                    </v-card>
                                </td>
                            </template>
                            <template v-slot:[`item.toReport`]="{ item }">
                                <v-checkbox v-model="item.toReport" :ripple="false"> </v-checkbox>
                            </template>
                            <template v-slot:[`item.amountNM1`]="{ item }">
                                {{ newCommonFormatCurrency(item.amountNM1, undefined) }}
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-window-item>
            <v-window-item value="2" style="overflow-y: auto">
                <v-card style="box-shadow: none" class="d-flex flex-column">
                    <v-card-text stye="overflow-y: auto; height:75vh;">
                        <v-data-table
                            :headers="dataTableHeader"
                            :items="formBfaa.sales"
                            :itemsPerPage="formBfaa.sales.length"
                            :single-expand="false"
                            v-model:expanded="salesExpanded"
                            item-value="aaName"
                            hide-default-footer
                            :loading="loading"
                            class="table"
                            v-if="formBfaa.sales"
                            density="compact"
                        >
                            <template v-slot:expanded-row="{ columns, item }">
                                <td :colspan="columns.length">
                                    <v-card style="box-shadow: none" class="d-flex flex-column">
                                        <v-card-text stye="overflow-y: auto; height:75vh;">
                                            <v-data-table
                                                :headers="subLineTableHeaders"
                                                :items="item.subLines"
                                                :itemsPerPage="item.subLines.length"
                                                item.key="companyName"
                                                hide-default-footer
                                                :loading="loading"
                                                class="table"
                                                elevation="0"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td class="pl-0 pr-2 py-0 ma-0">
                                                            <v-checkbox
                                                                v-model="props.item.toReport"
                                                                :ripple="false"
                                                                @change="
                                                                    changeYearlyLineSelection(
                                                                        props.item,
                                                                    )
                                                                "
                                                            >
                                                            </v-checkbox>
                                                        </td>
                                                        <td class="pl-0 pr-2 py-0 ma-0">
                                                            {{ props.item.companyName }}
                                                        </td>
                                                        <td class="pl-0 pr-2 py-0 ma-0">
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    props.item.amountNM1,
                                                                    undefined,
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-card-text>
                                    </v-card>
                                </td>
                            </template>
                            <template v-slot:[`item.toReport`]="{ item }">
                                <v-checkbox v-model="item.toReport" :ripple="false"> </v-checkbox>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-window-item>
        </v-tabs-window>
        <oss-dialog
            v-model="displayMergeDialog"
            @valid="mergeSelectedLines"
            validTitle="Fusionner les lignes sélectionnées"
        >
            <v-card style="box-shadow: none" class="d-flex flex-column">
                <v-card-title> Fusion de lignes </v-card-title>
                <v-card-text style="height: 75vh">
                    <v-tabs v-model="stepMergeDialog" fixed-tabs>
                        <v-tab value="1" href="#1" style="justify-content: left">
                            Lignes recommandées
                        </v-tab>
                        <v-tab value="2" href="#2" style="justify-content: left">
                            Toutes les lignes
                        </v-tab>
                        <v-tabs-window v-model="stepMergeDialog" style="overflow-y: auto">
                            <v-window-item value="1" style="overflow-y: auto">
                                <v-card style="box-shadow: none" class="d-flex flex-column">
                                    <v-card-text style="height: 75vh">
                                        <v-data-table
                                            :items="recommandedCharges"
                                            :headers="mergeHeaders"
                                            :itemsPerPage="recommandedCharges.length"
                                            hide-default-footer
                                            class="table"
                                        >
                                            <template v-slot:item="props">
                                                <tr>
                                                    <td class="pl-0 pr-1 py-0 ma-0">
                                                        <v-checkbox
                                                            v-model="props.item.toMerge"
                                                            :ripple="false"
                                                        >
                                                        </v-checkbox>
                                                    </td>
                                                    <td class="pl-0 pr-1 py-0 ma-0">
                                                        <v-text-field-filled
                                                            v-model="props.item.company"
                                                            outlined
                                                            density="compact"
                                                        />
                                                    </td>
                                                    <td class="pl-0 pr-0 py-0 ma-0">
                                                        {{ props.item.amount }}
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-window-item>
                            <v-window-item value="2" style="overflow-y: auto">
                                <v-card style="box-shadow: none" class="d-flex flex-column">
                                    <v-card-text style="height: 75vh">
                                        <v-data-table
                                            :items="allCharges"
                                            :headers="mergeHeaders"
                                            :itemsPerPage="allCharges.length"
                                            hide-default-footer
                                            class="table"
                                        >
                                            <template v-slot:item="props">
                                                <tr>
                                                    <td class="px-2 py-0 ma-0">
                                                        <v-checkbox
                                                            v-model="props.item.toMerge"
                                                            :ripple="false"
                                                        >
                                                        </v-checkbox>
                                                    </td>
                                                    <td class="pr-2 py-0 ma-0">
                                                        {{ props.item.company }}
                                                    </td>
                                                    <td class="py-0 ma-0">
                                                        {{ props.item.amount }}
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-window-item>
                        </v-tabs-window>
                    </v-tabs>
                </v-card-text>
            </v-card>
        </oss-dialog>
    </v-card>
</template>

<script lang="ts">
import BudgetDetails from "./BudgetDetails.vue";
import { State2Way } from "@/decorators";

import "moment/locale/pt-br";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        BudgetDetails,
    },
})
export class BudgetFormAccountableAccount extends Vue {
    // @Prop({ default: "" }) id: string;
    // @Prop({ default: false }) value: boolean;
    @Prop({ default: {} }) formBfaa: any;
    @Prop({ default: "AA" }) chargesGroupingMode: string;
    // @Prop({ default: false }) emitForm: boolean;

    @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    selectedAccountingPeriod!: any;

    // get selectedCompany() {
    //     return this.$store.state.selected_company;
    // }

    // expanded: any = []
    // singleExpand = false

    yearlyBalances: any = null;

    skip6And7Query = false;
    budgetId: string = null;
    width = "100%";
    height = "95%";
    dispatchedItems = [];
    step: string = "1";

    chargesExpanded = [];
    staffExpanded = [];
    salesCostsExpanded = [];
    salesExpanded = [];

    datasets = ["charges", "staff", "sales"];
    validLoading: boolean = false;
    relatedBffId: string = "";

    displayMergeDialog: boolean = false;
    mergingSource: any = null; // points towards charge line from which the merging dialog has been summoned
    stepMergeDialog: string = "1";
    archivedLines: Array<any> = [];

    bffGenerationMode: string = "AA";
    displayBFFGenerationSelector: boolean = false;

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    grossData = [];

    get allCharges() {
        const allChargesList = [];
        if (
            !this.monthly6And7Balances ||
            !this.monthly6And7Balances.charges ||
            !this.mergingSource
        ) {
            return allChargesList;
        }
        for (const line of this.monthly6And7Balances.charges) {
            if (line.accountableAccount.name !== this.mergingSource.accountableAccount.name) {
                const mergeLine = {
                    toMerge: false,
                    company: line.accountableAccount.name,
                    amount: line.amountNM1,
                };
                allChargesList.push(mergeLine);
            }
        }
        return allChargesList;
    }

    get recommandedCharges() {
        // const mergeCharges = this.allCharges;
        // const selection = [];
        // for (const charge of mergeCharges) {
        //     const testCompanyName = this.recommandByCompanyName(charge, this.mergingSource);
        // }
        // return selection;
        return [];
    }

    get linesMergeSelection() {
        const selection = [];
        for (const line of this.allCharges) {
            if (line.toMerge) {
                selection.push(line);
            }
        }
        return selection;
    }

    mergeHeaders = [
        { title: "Fusionner", value: "toMerge" },
        { title: "Fournisseur", value: "company" },
        { title: "Montant", value: "amount" },
        // {title: "", value: ""},
    ];

    subLineTableHeaders = [
        { title: "Reporter", value: "toReport" },
        { title: "Fournisseur", value: "companyName" },
        { title: "Montant annuel HT", value: "amountNM1" },
    ];

    subLineTableHeadersStaff = [
        { title: "Reporter", value: "toReport" },
        { title: "Fournisseur", value: "companyName" },
        { title: "Salaire annuel brut", value: "amountNM1" },
    ];

    monthly6And7Balances: any = {
        charges: [],
        staff: [],
        salesCosts: [],
        sales: [],
    };

    budgetName: string = "Nouveau budget N-1";

    // skipDescriptionsQuery: boolean = true;
    aaNamesList: Array<string> = [];

    editProperties = {
        snack: false,
        snackColor: "success",
        snackText: "",
        max15chars: (v) => v.length <= 15 || "Input too long",
    };

    get dataChargeTableHeader() {
        const headers = [
            { title: "Reporter la ligne", value: "toReport" },
            { title: "Compte comptable", value: "aaName" },
            { title: "Description", value: "aaDescription" },
            { title: "Montant N-1", value: "amountNM1" },
            // {title: "Méthode de génération", value: "generationMethod.mode"},
            // {title: "Pourcentage / Montant", value: "generationMethod.value"},
            // {title: "Amount N", value: "amountN"},
            { title: "Charge fixe / variable", value: "variability" },
            { key: "data-table-expand", align: "end" },
        ];
        if (this.step === "2") {
            headers.splice(5, 0, { title: "Ligne correspondante", value: "relatedLine" });
        } else if (this.step === "3") {
            headers.splice(5, 0, { title: "Vente correspondante", value: "relatedLine" });
        } else if (this.step === "4") {
            headers.splice(5, 0, { title: "Charge correspondante", value: "relatedLine" });
        } else if (this.step === "1" && this.chargesGroupingMode === "TPC") {
            headers.splice(5, 0, { title: "Actions", value: "actions" });
        }
        return headers;
    }

    get dataTableHeader() {
        const headers = [
            { title: "Reporter la ligne", value: "toReport" },
            { title: "Compte comptable", value: "aaName" },
            { title: "Description", value: "aaDescription" },
            { title: "Montant N-1", value: "amountNM1" },
            // {title: "Méthode de génération", value: "generationMethod.mode"},
            // {title: "Pourcentage / Montant", value: "generationMethod.value"},
            // {title: "Amount N", value: "amountN"},
            { key: "data-table-expand", align: "end" },
        ];
        if (this.step === "2") {
            headers.splice(4, 0, { title: "Ligne correspondante", value: "relatedLine" });
        } else if (this.step === "3") {
            headers.splice(4, 0, { title: "Vente correspondante", value: "relatedLine" });
        } else if (this.step === "4") {
            headers.splice(4, 0, { title: "Charge correspondante", value: "relatedLine" });
        } else if (this.step === "1" && this.chargesGroupingMode === "TPC") {
            headers.splice(4, 0, { title: "Actions", value: "actions" });
        }
        return headers;
    }

    chargeTypes = ["fixe", "variable"];

    monthList = [
        "Janv",
        "Févr",
        "Mars",
        "Avr",
        "Mai",
        "Juin",
        "Juil",
        "Aout",
        "Sept",
        "Oct",
        "Nov",
        "Déc",
    ];

    Fake1BudgetFormAccountableAccount: any = [
        {
            accountableAccount: {
                name: "Fake1",
                description: "Fake accountable account number 1 for test data, the real one",
                type: "Purchase",
            },
            amounts: [
                {
                    budget: [
                        { date: "01/2020", amountSigned: 45000, hasBeenManuallyModified: false },
                        { date: "02/2020", amountSigned: 48000, hasBeenManuallyModified: false },
                        { date: "03/2020", amountSigned: 44000, hasBeenManuallyModified: false },
                        { date: "04/2020", amountSigned: 45000, hasBeenManuallyModified: false },
                        { date: "05/2020", amountSigned: 49000, hasBeenManuallyModified: false },
                        { date: "06/2020", amountSigned: 50000, hasBeenManuallyModified: false },
                        { date: "07/2020", amountSigned: 47000, hasBeenManuallyModified: false },
                        { date: "08/2020", amountSigned: 49000, hasBeenManuallyModified: false },
                        { date: "09/2020", amountSigned: 50000, hasBeenManuallyModified: false },
                        { date: "10/2020", amountSigned: 52000, hasBeenManuallyModified: false },
                        { date: "11/2020", amountSigned: 55000, hasBeenManuallyModified: false },
                        { date: "12/2020", amountSigned: 56000, hasBeenManuallyModified: false },
                    ],
                    title: "Exercice 2020",
                    firstMonth: "01/2020",
                    lastMonth: "12/2020",
                    editable: false,
                    isBaseForCalculation: true,
                    isTotal: false,
                    name: "Fake1",
                },
                {
                    budget: [
                        { date: "01/2021", amountSigned: 45000, hasBeenManuallyModified: false },
                        { date: "02/2021", amountSigned: 48000, hasBeenManuallyModified: false },
                        { date: "03/2021", amountSigned: 44000, hasBeenManuallyModified: false },
                        { date: "04/2021", amountSigned: 45000, hasBeenManuallyModified: false },
                        { date: "05/2021", amountSigned: 49000, hasBeenManuallyModified: false },
                        { date: "06/2021", amountSigned: 50000, hasBeenManuallyModified: false },
                        { date: "07/2021", amountSigned: 47000, hasBeenManuallyModified: false },
                        { date: "08/2021", amountSigned: 49000, hasBeenManuallyModified: false },
                        { date: "09/2021", amountSigned: 50000, hasBeenManuallyModified: false },
                        { date: "10/2021", amountSigned: 52000, hasBeenManuallyModified: false },
                        { date: "11/2021", amountSigned: 55000, hasBeenManuallyModified: false },
                        { date: "12/2021", amountSigned: 56000, hasBeenManuallyModified: false },
                    ],
                    title: "Exercice 2021",
                    firstMonth: "01/2021",
                    lastMonth: "12/2021",
                    editable: true,
                    isBaseForCalculation: false,
                    isTotal: false,
                    name: "Fake1",
                },
            ],
            total: {
                budget: [
                    { date: "01/2021", amountSigned: 45000, hasBeenManuallyModified: false },
                    { date: "02/2021", amountSigned: 48000, hasBeenManuallyModified: false },
                    { date: "03/2021", amountSigned: 44000, hasBeenManuallyModified: false },
                    { date: "04/2021", amountSigned: 45000, hasBeenManuallyModified: false },
                    { date: "05/2021", amountSigned: 49000, hasBeenManuallyModified: false },
                    { date: "06/2021", amountSigned: 50000, hasBeenManuallyModified: false },
                    { date: "07/2021", amountSigned: 47000, hasBeenManuallyModified: false },
                    { date: "08/2021", amountSigned: 49000, hasBeenManuallyModified: false },
                    { date: "09/2021", amountSigned: 50000, hasBeenManuallyModified: false },
                    { date: "10/2021", amountSigned: 52000, hasBeenManuallyModified: false },
                    { date: "11/2021", amountSigned: 55000, hasBeenManuallyModified: false },
                    { date: "12/2021", amountSigned: 56000, hasBeenManuallyModified: false },
                ],
                title: "Total 2021",
                firstMonth: "01/2021",
                lastMonth: "12/2021",
                editable: false,
                isBaseForCalculation: false,
                isTotal: true,
                name: "Fake1",
            },
            toReport: true,
            amountNM1: 0,
            amountN: 0,
            generationMethod: { mode: "Pourcentage", value: 100 },
            chargeType: "variable",
        },
    ];

    generationMethods: any = [
        { id: "pourc", name: "Par un pourcentage du montant de l'année précédente" },
        { id: "mont", name: "Par un montant annuel divisé entre les mois" },
        { id: "affi", name: "Par un ajout au montant de l'année précédente" },
    ];

    get relatedLines641() {
        const lines = ["Aucune"];
        if (this.monthly6And7Balances.staff) {
            for (const line of this.monthly6And7Balances.staff) {
                if (line.accountableAccount.name.slice(0, 3) === "645" && line.toReport) {
                    lines.push(line.accountableAccount.name);
                }
            }
        }
        return lines;
    }

    get relatedLines645() {
        const lines = ["Aucune"];
        if (this.monthly6And7Balances.staff) {
            for (const line of this.monthly6And7Balances.staff) {
                if (line.accountableAccount.name.slice(0, 3) === "641" && line.toReport) {
                    lines.push(line.accountableAccount.name);
                }
            }
        }
        return lines;
    }

    get relatedLines60() {
        const lines = ["Aucune"];
        if (this.monthly6And7Balances.sales) {
            for (const line of this.monthly6And7Balances.sales) {
                if (line.toReport) {
                    lines.push(line.accountableAccount.name);
                }
            }
        }
        return lines;
    }

    get relatedLines7() {
        const lines = ["Aucune"];
        if (this.monthly6And7Balances.salesCosts) {
            for (const line of this.monthly6And7Balances.salesCosts) {
                if (line.toReport) {
                    lines.push(line.accountableAccount.name);
                }
            }
        }
        return lines;
    }

    skip: boolean = false;

    accountingLinesList = [];

    displayMenu = {};

    get loading() {
        return false;
    }

    findMergeLineInCharges(mergeLine) {
        // find line (corresponding to compressed format line from allCharges) in monthly6And7Balances.charges and return it
        const index = this.formBfaa.charges.findIndex(
            (charge) => charge.accountableAccount.name === mergeLine.company,
        );
        return this.formBfaa.charges[index];
    }

    mergeLines(line1, line2) {
        // merge line2 into line1
        // merging is taking the total amount and the monthly amounts,
        // further, it should be possible to transfere relatedLines
        const newBudget = [];
        for (const month in line1.amounts[0].budget) {
            const amountSigned =
                line1.amounts[0].budget[month].amountSigned +
                line2.amounts[0].budget[month].amountSigned;
            const date = line1.amounts[0].budget[month].date;
            const budgetMonth = {
                amountSigned: amountSigned,
                date: date,
                hasBeenManuallyModified: false,
            };
            newBudget.push(budgetMonth);
        }
        line1.amounts[0].budget = newBudget;
        line1.amountNM1 = parseFloat(line1.amountNM1) + parseFloat(line2.amountNM1);
        line1.amountN = parseFloat(line1.amountN) + parseFloat(line2.amountN);
        this.archiveLine(line2);
    }

    mergeSelectedLines() {
        // merge all the selectedLines from the merge dialog into a single line
        for (const line of this.linesMergeSelection) {
            this.mergeLines(this.mergingSource, this.findMergeLineInCharges(line));
        }
        this.displayMergeDialog = false;
    }

    recommandByCompanyName(possibleMerge, source) {
        // possibleMerge is the line currently observed to know whether it is a good match for the source line to be merged with
        // recommandation by company name use common prefix comparison
        // criteria : if common prefix
        // for (let index = 0; index < source.accountableAccount.name) {
        // }
    }

    archiveLine(line) {
        // store lines in a dedicated list and delete them from the rendered data table items
        this.archivedLines.push(line);
        const index = this.formBfaa.charges.findIndex(
            (chargeLine) => chargeLine.accountableAccount.name === line.accountableAccount.name,
        );
        this.formBfaa.charges.splice(index, 1);
    }

    changeYearlyLineSelection(subLine) {
        const amount = subLine.toReport ? subLine.amountNM1 : -subLine.amountNM1;
        const expanded =
            this.step === "1"
                ? this.chargesExpanded
                : this.step === "2"
                  ? this.salesExpanded
                  : this.staffExpanded;
        expanded[0].amountNM1 += amount;
        expanded[0].toReport = this.isYearlyLineReportable(expanded[0].subLines);
    }

    isYearlyLineReportable(subLines) {
        for (const subLine of subLines) {
            if (subLine.toReport) {
                return true;
            }
        }
        return false;
    }

    // computeYearlyList(result) {
    //     // result has format :
    //     // aa, year, month,
    // }

    // fillDetails(data) {
    //     // transform the result of yearlyToMonthly6And7Balances
    //     // input has months list of date * amount with only months for which AL exist
    //     // method add the missing months with amount 0
    //     // PREREQUISITE : MONTHLIST HAS TO BE SORTED ACCORDING TO TIMELINE
    //     for (const line of data) {
    //         const newMonthsList = JSON.parse(JSON.stringify(line.months))
    //         let firstMonth = moment(this.selectedAccountingPeriod.start).startOf('month')
    //         for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
    //             const currentMonth = firstMonth.clone().add(monthIndex, 'months').format('MM-YYYY')
    //             if (!line.months.find(month => month.date === currentMonth)) {
    //                 newMonthsList.splice(monthIndex, 0, {date: currentMonth, amount: 0})
    //             }
    //         }
    //         line.months = newMonthsList
    //     }
    //     return data
    // }
}

export default toNative(BudgetFormAccountableAccount);
</script>
